// BUNDLED: global-bundle.js
let viewExtend = Backbone.View.extend;
let viewProto = Backbone.View.prototype;

// old way to override models, by grabbing off of a view during its construction, kept for legacy functionality
// example: to override a view where viewName = 'Menu', use CCRZ.pubSub.on('view:Menu:constructed', (viewProto, options) => {});
Backbone.View = function(options) {
	CCRZ.pubSub.trigger('view:' + this.viewName + ':constructed', this, options);
	viewProto.constructor.call(this, options);
}

// primary way to override views
// example: to override a view where viewName = 'Menu', use CCRZ.pubSub.on('view:Menu:created', (viewProto) => { });
Backbone.View.prototype = viewProto;
Backbone.View._extend = viewExtend;
Backbone.View.extend = function (viewProto, finalView) {
	if (viewProto.viewName) {
		CCRZ.pubSub.trigger('view:' + viewProto.viewName + ':created', viewProto);
	}
	return this._extend(viewProto, finalView);
};

// primary way to override models
// example: to override CCRZ.models.CartDetail, use CCRZ.pubSub.on('model:CartDetail:created')
let models = CCRZ.models;
CCRZ.models = new Proxy(models, {
    set: function (target, name, modelProto) {
        CCRZ.pubSub.trigger('model:' + name + ':created', modelProto.prototype);
        target[name] = modelProto;
        return true;
    },
});

// triggers pubSub events when user resizes the screen past breakpoints.
// example:
// CCRZ.pubSub.on('breakpoint:change', (newBreakpoint) => {
//        if (newBreakpoint == 'tablet'){
//             //do something
//        }
// });
jQuery(function ($) {
    CCRZ.breakpoints = {
        'mobile' : {'low':0, 'hi':480},
        'tablet' : {'low':481, 'hi':768},
        'desktopSm' : {'low':769, 'hi':992},
        'desktopLg' : {'low':992, 'hi':1188},
        'ultraWide' : {'low':1189, 'hi':Number.MAX_VALUE}
    }
    CCRZ.prevScreenSize = $(window).width();
    CCRZ.currBreakpoint = _.findKey(CCRZ.breakpoints, getInitBreakPoint);
    $(window).resize(function () {
        CCRZ.currScreenSize = $(window).width();
        let newBreakpoint = _.findKey(CCRZ.breakpoints, checkBreakPoints);
        if (newBreakpoint){
            CCRZ.currBreakpoint = newBreakpoint;
            CCRZ.pubSub.trigger('breakpoint:change', newBreakpoint);
        }
        CCRZ.prevScreenSize = $(window).width();
    });
    
    function checkBreakPoints(breakpoint) {
        return (CCRZ.prevScreenSize < breakpoint.low && CCRZ.currScreenSize >= breakpoint.low ||
                    CCRZ.prevScreenSize > breakpoint.hi && CCRZ.currScreenSize <= breakpoint.hi) 
    }

    function getInitBreakPoint(breakpoint) {
        return (CCRZ.prevScreenSize <= breakpoint.hi && CCRZ.prevScreenSize >= breakpoint.low);
    }
});

CCRZ.makeRemoteAction = function (className, methodName, args = [], buffer = false) {
    args = args instanceof Array ? args : [args];
    const remote = _.extend(CCRZ.RemoteInvocation, { className: className});
    return new Promise(function(resolve, reject) {
        remote.invokeCtx(methodName, ...args, (res, err) => {
            res?.success ? resolve(res.data) : reject(err);
        },
        {nmsp: false, escape: false, buffer: buffer});
    });
}

CCRZ.renderHandlebars = function (templateId, data, containerSelector) {
	try {
		let template = Handlebars.compile($(`#${templateId}`).html());
        let html = template(data);
		containerSelector && $(containerSelector).html(template(data));
        return html;
	} catch (error) {
		console.error(`error when rendering template ${templateId}`, error);
	}
};

function setOneTrustGroups() {
    let groups = OnetrustActiveGroups.split(',').filter((x) => x);
    CCRZ.pagevars.cookieConsentGroups = groups || [];
    CCRZ.pubSub.trigger('cookieConsentUpdate');
}

export { setOneTrustGroups };
